function isSameAsDeletedUser({ state, output }) {
  let { user, delete: { user: deletedUser } } = state.get('client')
  if (user._id === deletedUser._id) {
    output.true()
  } else {
    output.false()
  }
}

isSameAsDeletedUser.outputs = ['true', 'false']

export default isSameAsDeletedUser



// WEBPACK FOOTER //
// ./src/modules/user/actions/isSameAsDeletedUser.js